/**
 * Проверка адресов из ответа модели и карточек. Внутри кабинета только
 * пути /partner (без "//host" и обратных слешей: браузер читает их как
 * другой сайт), наружу только http(s). Остальное (javascript:, data:,
 * mailto: и т.п.) ссылкой не становится.
 */
const CABINET_ROOT = "/partner";

/** Путь после разбора браузером: точки и %2e%2e схлопываются, как при переходе. */
function resolvedPathname(url: string): string | null {
  try {
    const parsed = new URL(url, "https://x.invalid");
    if (parsed.origin !== "https://x.invalid") return null;
    return decodeURIComponent(parsed.pathname);
  } catch {
    return null;
  }
}

export const isCabinetPath = (
  url: string | null | undefined
): url is string => {
  if (!url || !/^\/partner(?:[/?#]|$)/.test(url) || url.includes("\\"))
    return false;
  const path = resolvedPathname(url);
  if (path === null || path.includes("..")) return false;
  return path === CABINET_ROOT || path.startsWith(`${CABINET_ROOT}/`);
};

export const isHttpUrl = (url: string | null | undefined): url is string => {
  if (!url || !/^https?:\/\//i.test(url)) return false;
  try {
    return !!new URL(url).host;
  } catch {
    return false;
  }
};
